import React from 'react';

import get from 'lodash/get';

import {
  DescriptionList,
  DescriptionItem,
  Link,
  Typography,
} from '@gogame/components';
import { useCurrencyFormat } from '@gogame/intl-ts';

const General = ({
  data,
  onOpenMasterCampaign,
  onOpenPromoCode,
  onOpenAffiliate,
  onOpenInfluencer,
  onOpenInfluencerChannel,
}) => {
  const currencyFormatter = useCurrencyFormat({
    currency: data?.currencyCode,
  });

  return (
    <DescriptionList disableGutters data={data}>
      <DescriptionItem
        label={'Period'}
        field={'masterCampaignStartDate'}
        type={'date'}
        template={'MONTH'}
      />
      <DescriptionItem
        label={'Master campaign'}
        field={'masterCampaign'}
        type={'link'}
        linkLabelField={'name'}
        onValueClick={onOpenMasterCampaign}
      />
      <DescriptionItem label={'Application'} field={'application.name'} />
      <DescriptionItem label={'Network'} field={'network.name'} />
      <DescriptionItem
        label={'Platforms'}
        field={'platforms'}
        valueParser={'commaList'}
      />
      <DescriptionItem label={'Brief'} field={'brief.name'} />
      <DescriptionItem label={'Country'} field={'country.name'} />
      <DescriptionItem
        label={'Promo code'}
        field={'promoCode'}
        type={'link'}
        linkLabelField={'name'}
        onValueClick={onOpenPromoCode}
      />{' '}
      {/*TODO: check promoCode*/}
      <DescriptionItem
        label={'Conversion page'}
        field={'conversionPage'}
        type={'link'}
        linkLabelField={'name'}
        target={'_blank'}
        style={{
          wordBreak: 'break-all',
        }}
        href={data?.conversionPage?.name}
      />
      <DescriptionItem
        label={'IOS Conversion page'}
        field={'iOsConversionPage'}
        type={'link'}
        linkLabelField={'name'}
        target={'_blank'}
        href={data?.iOsConversionPage?.name}
      />
      <DescriptionItem
        label={'Android Conversion page'}
        field={'androidConversionPage'}
        type={'link'}
        linkLabelField={'name'}
        target={'_blank'}
        href={data?.androidConversionPage?.name}
      />
      <DescriptionItem
        label={'Influencer details'}
        value={data?.agency || data?.influencer || data?.influencerChannel}
        type={({ value: omittedValue, ...other }) => {
          return (
            <Typography {...other}>
              <Link
                onClick={(e) =>
                  onOpenAffiliate(e, {
                    id: data?.agency?.id,
                  })
                }
              >
                {data?.agency?.name}
              </Link>
              {' / '}
              <Link
                onClick={(e) =>
                  onOpenInfluencer(e, {
                    id: data?.influencer?.id,
                  })
                }
              >
                {data?.influencer?.name}
              </Link>
              {' / '}
              <Link
                onClick={(e) =>
                  onOpenInfluencerChannel(e, {
                    id: data?.influencerChannel?.id,
                  })
                }
              >
                {data?.influencerChannel?.name}
              </Link>
            </Typography>
          );
        }}
      />
      <DescriptionItem
        label={'Payout / Rate'}
        field={'payout'}
        valueParser={(payout) => {
          const event = get(data, 'costModelSubType.name');
          return `${currencyFormatter(
            payout
          )} (${data?.currencyCode?.toUpperCase()}) ${get(
            data,
            'costModel.name'
          )}${event ? ' - ' + event : ''}`;
        }}
      />
      <DescriptionItem label={'Template Id'} field={'templateId'} />
      <DescriptionItem
        label={'Creative URL'}
        field={'creativeUrl'}
        type={'link'}
        href={data?.creativeUrl}
        target={'_blank'}
      />
      <DescriptionItem
        label={'Promo details'}
        field={'promo'}
        valueParser={(promo) => {
          return `${promo?.duration.substr(-5)} ${
            promo?.locationType.name
          } starting at ${promo?.startingPoint.substr(-8)}`;
        }}
      />
      <DescriptionItem
        label={'Label'}
        field={'label'}
        type={'link'}
        href={'/'}
      />
      <DescriptionItem
        limit={5}
        listType={'bullet'}
        label={'IOS CPP'}
        type={'typographyList'}
        field={'ggLinks.hybridLinkParameters.iosCpp'}
        getLabel={(label) => label}
      />
      <DescriptionItem
        limit={5}
        listType={'bullet'}
        label={'Android CPP'}
        type={'typographyList'}
        field={'ggLinks.hybridLinkParameters.androidCpp'}
        getLabel={(label) => label}
      />
    </DescriptionList>
  );
};

export default General;
